module.exports = __webpack_public_path__ + "static/img/05normal.b4733d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/09startTrain/05normal.png
// module id = 8TLP
// module chunks = 0